import { Star } from "lucide-react";
import { FadeUp } from "./FadeUp";

const TESTIMONIALS = [
  {
    id: 1,
    name: "Rohan Mehta",
    city: "Mumbai",
    result: "Lost 9 kg in 12 weeks",
    before: "71kg",
    after: "62kg",
    quote: "The Indian meal plans actually fit my life. I never felt like I was on a 'diet'.",
    avatar: "https://images.unsplash.com/photo-1790575188672-ee8d9d4e1c18?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: 2,
    name: "Priya Nair",
    city: "Bengaluru",
    result: "Gained 4 kg lean muscle in 4 months",
    before: "54kg",
    after: "58kg",
    quote: "The workout logger kept me accountable every single session. Game changer.",
    avatar: "https://images.unsplash.com/photo-1725033489648-a819750348eb?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: 3,
    name: "Ananya Rao",
    city: "Hyderabad",
    result: "120 workouts logged this year",
    before: "Inconsistent",
    after: "Everyday",
    quote: "First time I've stayed consistent for this long. The tracking just works.",
    avatar: "https://images.unsplash.com/photo-1708011108776-45ad9e625269?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export const Testimonials = () => (
  <section id="results" className="py-14 md:py-20 px-6 bg-[#111113]">
    <div className="max-w-6xl mx-auto">
      <FadeUp>
        <h2 className="font-display text-4xl sm:text-5xl text-white text-center mb-10 md:mb-14">
          REAL PEOPLE. REAL RESULTS.
        </h2>
      </FadeUp>
      <div className="grid md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <FadeUp key={t.id} delay={i * 0.1}>
            <div
              data-testid={`testimonial-card-${t.id}`}
              className="bg-[#1A1A1D] border border-[#2a2a2e] rounded-[24px] p-8 h-full hover:-translate-y-1.5 hover:border-[#C6FF3D]/40 transition-all duration-300"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, idx) => (
                  <Star key={idx} size={14} className="text-[#C6FF3D]" fill="#C6FF3D" />
                ))}
              </div>
              <div className="flex items-center gap-2 mb-5">
                <span className="bg-[#C6FF3D]/10 text-[#C6FF3D] text-xs font-semibold px-3 py-1 rounded-full">
                  {t.result}
                </span>
              </div>
              <div className="flex items-center gap-2 mb-5 text-xs">
                <span className="bg-[#0A0A0B] border border-[#232326] text-[#A1A1AA] px-3 py-1.5 rounded-full">{t.before}</span>
                <span className="text-[#C6FF3D]">→</span>
                <span className="bg-[#0A0A0B] border border-[#C6FF3D]/30 text-[#C6FF3D] px-3 py-1.5 rounded-full">{t.after}</span>
              </div>
              <p className="text-white text-sm mb-6 leading-relaxed">"{t.quote}"</p>
              <div className="flex items-center gap-3">
                <img src={t.avatar} alt={`${t.name}, FORGE member from ${t.city}`} className="w-11 h-11 rounded-full object-cover" />
                <div>
                  <p className="text-white text-sm font-semibold">{t.name}</p>
                  <p className="text-[#A1A1AA] text-xs">{t.city}</p>
                </div>
              </div>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
